require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-2018-gift-guide-for-software-developers.json") })
        }
      }, "path---blog-the-2018-gift-guide-for-software-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-2018-gift-guide-for-software-developers!./.cache/json/blog-the-2018-gift-guide-for-software-developers.json
// module id = 1080
// module chunks = 231608221292675